export default __webpack_public_path__ + "static/media/no-limits.8047dadb.svg";